import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { SearchBox, useSearchBox } from 'react-instantsearch';
import { get, debounce } from 'lodash';
import avo from 'analytics/avo';
import { ALGOLIA_INDEX_NAME } from 'commons/constants';
import isClient from 'commons/isClient';
import useIsBrowser from 'hooks/useIsBrowser';
import IconSearch from 'components/icons/IconSearch';
import IconClose from 'components/icons/iconClose';
import useScreen from 'hooks/useScreen';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import { getAdvancedSearchUrlForQueryAndIndex } from 'components/consumer/consumer-search/commons/helpers';
const JBSearchBox = t0 => {
  const $ = _c(78);
  let advanced;
  let autoFocus;
  let forPage;
  let handleSearchBarFocus;
  let index;
  let initialQueryValue;
  let isActive;
  let otherProps;
  let setInactive;
  let setSearchStateQuery;
  let t1;
  let t2;
  let toggleMobileSearchBar;
  let variant;
  if ($[0] !== t0) {
    ({
      advanced,
      autoFocus,
      forPage,
      index,
      inMobileNav: t1,
      isActive,
      placeholder: t2,
      setInactive,
      variant,
      initialQueryValue,
      setSearchStateQuery,
      toggleMobileSearchBar,
      handleSearchBarFocus,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = advanced;
    $[2] = autoFocus;
    $[3] = forPage;
    $[4] = handleSearchBarFocus;
    $[5] = index;
    $[6] = initialQueryValue;
    $[7] = isActive;
    $[8] = otherProps;
    $[9] = setInactive;
    $[10] = setSearchStateQuery;
    $[11] = t1;
    $[12] = t2;
    $[13] = toggleMobileSearchBar;
    $[14] = variant;
  } else {
    advanced = $[1];
    autoFocus = $[2];
    forPage = $[3];
    handleSearchBarFocus = $[4];
    index = $[5];
    initialQueryValue = $[6];
    isActive = $[7];
    otherProps = $[8];
    setInactive = $[9];
    setSearchStateQuery = $[10];
    t1 = $[11];
    t2 = $[12];
    toggleMobileSearchBar = $[13];
    variant = $[14];
  }
  const inMobileNav = t1 === undefined ? false : t1;
  const placeholder = t2 === undefined ? "What can we help you find?" : t2;
  const history = useHistory();
  const location = useLocation();
  const currentPage = useUserCurrentPageType();
  const [searchQuery, updateSearchQuery] = useState(initialQueryValue);
  const {
    isMobile
  } = useScreen();
  const isBrowser = useIsBrowser();
  const {
    query
  } = useSearchBox();
  let t3;
  if ($[15] !== isBrowser || $[16] !== setSearchStateQuery) {
    t3 = debounce(updatedValue => {
      if (isBrowser && setSearchStateQuery) {
        setSearchStateQuery(updatedValue);
      }
    }, 250);
    $[15] = isBrowser;
    $[16] = setSearchStateQuery;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  const debouncedSearchStateQueryUpdate = t3;
  let t4;
  if ($[18] !== debouncedSearchStateQueryUpdate) {
    t4 = event => {
      updateSearchQuery(event.target.value);
      debouncedSearchStateQueryUpdate(event.target.value);
    };
    $[18] = debouncedSearchStateQueryUpdate;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  const handleQueryChange = t4;
  let t5;
  if ($[20] !== currentPage || $[21] !== history || $[22] !== index || $[23] !== isBrowser || $[24] !== otherProps || $[25] !== query) {
    t5 = () => {
      if (isBrowser) {
        avo.productsSearched({
          query,
          location: currentPage,
          searchTarget: avo.SearchTarget.FULL_RESULTS
        });
        const newUrl = getAdvancedSearchUrlForQueryAndIndex(query, index || ALGOLIA_INDEX_NAME.PRODUCTS, "*");
        history.push(newUrl, {
          instantQuery: query
        });
        otherProps?.toggleSearchOpen();
      }
    };
    $[20] = currentPage;
    $[21] = history;
    $[22] = index;
    $[23] = isBrowser;
    $[24] = otherProps;
    $[25] = query;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  const goToAdvancedSearch = t5;
  const t6 = variant === "ConsumerInstantSearch";
  let t7;
  if ($[27] !== t6) {
    t7 = classNames("[&_i]:w-[18px] [&_i]:h-[18px] [&_i]:text-[18px] [&_i]:block [&_i]:absolute [&_i]:top-1/2 [&_i]:mt-[-9px] [&_i]:right-10 [&_i]:cursor-pointer [&_i]:[border-right:1px_solid_#dfe0e1] bg-gray-light8", {
      "py-3": t6
    });
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  const t8 = variant !== "ConsumerInstantSearch";
  const t9 = variant === "ConsumerInstantSearch";
  const t10 = variant === "ConsumerInstantSearch" && isActive;
  const t11 = variant === "InstantSearchMobile";
  let t12;
  if ($[29] !== inMobileNav || $[30] !== t10 || $[31] !== t11 || $[32] !== t8 || $[33] !== t9) {
    t12 = classNames("mx-5 my-0 flex flex-row items-stretch relative box-border min-[1440px]:mx-[3.333vw] min-[1440px]:my-0", {
      "px-0 py-[5px]": t8,
      "!ml-3": inMobileNav,
      "px-3 bg-white rounded-[5px] border border-gray-light6 [&_.ais-SearchBox-input]:lg:!pl-0 [&_.ais-SearchBox-input]:lg:!text-left [&_.ais-SearchBox-input]:lg:!indent-[12px] [&_.ais-SearchBox-input::placeholder]:lg:!text-left [&_.ais-SearchBox-input.hasValue]:lg:!indent-[24px]": t9,
      "[&_button.ais-SearchBox-reset]:!block": t10,
      "[&_.ais-SearchBox-input]:indent-[12px]": t11
    });
    $[29] = inMobileNav;
    $[30] = t10;
    $[31] = t11;
    $[32] = t8;
    $[33] = t9;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  const t13 = variant === "InstantSearchMobile";
  let t14;
  if ($[35] !== t13) {
    t14 = classNames("self-center min-w-[16px]", {
      hidden: t13
    });
    $[35] = t13;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t14) {
    t15 = <IconSearch className={t14} width={18} height={18} />;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== advanced || $[40] !== handleQueryChange || $[41] !== placeholder || $[42] !== searchQuery) {
    t16 = advanced && <div className="inline-flex w-full pl-2"><div className="flex w-full"><input className="text-left pl-[30px] [appearance:unset] bg-none [background:none] border-[1px] border-solid border-transparent text-[#333] block [font-size:1rem] font-bold h-10 leading-[1.45rem] tracking-[-.0125rem] w-full" type="search" placeholder={placeholder} autoComplete="off" autoCapitalize="off" spellCheck={false} maxLength={512} value={searchQuery} onChange={handleQueryChange} /></div></div>;
    $[39] = advanced;
    $[40] = handleQueryChange;
    $[41] = placeholder;
    $[42] = searchQuery;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== advanced || $[45] !== autoFocus || $[46] !== currentPage || $[47] !== forPage || $[48] !== handleQueryChange || $[49] !== handleSearchBarFocus || $[50] !== history || $[51] !== index || $[52] !== isMobile || $[53] !== location || $[54] !== otherProps || $[55] !== placeholder || $[56] !== searchQuery || $[57] !== setInactive) {
    t17 = !advanced && <div className="inline-flex w-full [&_.ais-SearchBox-loadingIndicator]:hidden" onClick={handleSearchBarFocus} role="button" tabIndex={0}><SearchBox translations={{}} autoFocus={autoFocus} onFocus={event_0 => {
        if (!(advanced || forPage === "associate")) {
          event_0.currentTarget.placeholder = placeholder;
        }
      }} onBlur={event_1 => {
        if (!isMobile) {
          return;
        }
        const inputElement = event_1.currentTarget;
        const inputValue = inputElement?.value;
        if (inputElement) {
          inputElement.placeholder = placeholder;
        }
        if (inputValue?.length === 0) {
          const requiredNode = get(inputElement, "parentNode.parentNode.parentNode.parentNode");
          if (requiredNode) {
            requiredNode.classList.remove("active");
          }
        }
        if (setInactive !== undefined) {
          setInactive(true);
        }
      }} onInput={_temp} onChange={handleQueryChange} onKeyDown={e => {
        if (isMobile) {
          updateSearchQuery(e.currentTarget.value);
          if (otherProps.setSearchEventParams) {
            otherProps.setSearchEventParams({
              searchQuery: e.currentTarget.value,
              currentPage
            });
          }
          return;
        }
        if (forPage !== "associate" && +e.keyCode === 13 && e.target.value !== "" && isClient()) {
          avo.productsSearched({
            query: e.target.value,
            location: currentPage,
            searchTarget: avo.SearchTarget.FULL_RESULTS
          });
          const newUrl_0 = getAdvancedSearchUrlForQueryAndIndex(e.target.value, index || "products_jb4", "*");
          if (location.pathname === "/search/") {
            window.location.href = newUrl_0;
          } else {
            history.push(newUrl_0, {
              instantQuery: e.target.value
            });
            otherProps.toggleSearchOpen();
          }
        }
      }} onReset={async event_3 => {
        const target = event_3.currentTarget;
        const form = target?.closest(".ais-SearchBox-form");
        form?.querySelector(".ais-SearchBox-input")?.classList.remove("hasValue");
        if (!(advanced || forPage === "associate")) {
          await otherProps.toggleSearchOpen();
          if (isMobile) {
            setInactive?.();
            const requiredNode_0 = get(target, "parentNode.parentNode.parentNode");
            if (requiredNode_0) {
              requiredNode_0.classList.remove("active");
            }
            if (searchQuery && searchQuery.length > 0) {
              avo.productsSearched({
                query: searchQuery,
                location: currentPage,
                searchTarget: avo.SearchTarget.EXIT_SEARCH
              });
            }
          }
        }
      }} placeholder={placeholder} />{" "}</div>;
    $[44] = advanced;
    $[45] = autoFocus;
    $[46] = currentPage;
    $[47] = forPage;
    $[48] = handleQueryChange;
    $[49] = handleSearchBarFocus;
    $[50] = history;
    $[51] = index;
    $[52] = isMobile;
    $[53] = location;
    $[54] = otherProps;
    $[55] = placeholder;
    $[56] = searchQuery;
    $[57] = setInactive;
    $[58] = t17;
  } else {
    t17 = $[58];
  }
  let t18;
  if ($[59] !== goToAdvancedSearch || $[60] !== isBrowser || $[61] !== toggleMobileSearchBar || $[62] !== variant) {
    t18 = isBrowser && variant === "InstantSearchMobile" && <div className="flex gap-2 items-center"><IconSearch className="self-center min-w-[16px] cursor-pointer" width={18} height={18} onClick={goToAdvancedSearch} /><div className="text-gray">|</div><IconClose className="self-center min-w-[16px] cursor-pointer" width={14} height={14} color="#424242" onClick={toggleMobileSearchBar} /></div>;
    $[59] = goToAdvancedSearch;
    $[60] = isBrowser;
    $[61] = toggleMobileSearchBar;
    $[62] = variant;
    $[63] = t18;
  } else {
    t18 = $[63];
  }
  let t19;
  if ($[64] !== t12 || $[65] !== t15 || $[66] !== t16 || $[67] !== t17 || $[68] !== t18) {
    t19 = <div className={t12}>{t15}{" "}{t16}{t17}{" "}{t18}</div>;
    $[64] = t12;
    $[65] = t15;
    $[66] = t16;
    $[67] = t17;
    $[68] = t18;
    $[69] = t19;
  } else {
    t19 = $[69];
  }
  let t20;
  if ($[70] !== isActive || $[71] !== isMobile || $[72] !== variant) {
    t20 = isMobile && <div className={classNames("h-0 w-0 top-[65px] z-[-1] left-0 fixed bg-white [transition:opacity_.3s_ease-out] opacity-0 lg:absolute lg:bg-transparent", {
      active: isActive,
      hidden: variant === "InstantSearchMobile",
      "lg:opacity-100 lg:h-screen lg:w-screen lg:top-[-100px] lg:absolute lg:[transition:opacity_.3s_ease-out]": isActive
    })} />;
    $[70] = isActive;
    $[71] = isMobile;
    $[72] = variant;
    $[73] = t20;
  } else {
    t20 = $[73];
  }
  let t21;
  if ($[74] !== t19 || $[75] !== t20 || $[76] !== t7) {
    t21 = <div className={t7}>{t19}{" "}{t20}</div>;
    $[74] = t19;
    $[75] = t20;
    $[76] = t7;
    $[77] = t21;
  } else {
    t21 = $[77];
  }
  return t21;
};
export default JBSearchBox;
function _temp(event_2) {
  if (event_2.currentTarget.value?.length > 0) {
    event_2.currentTarget?.classList.add("hasValue");
  } else {
    event_2.currentTarget?.classList.remove("hasValue");
  }
}